const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "年份",
        prop: "year",
        search: true,
        searchSlot: true,
        clearable: true,
      },
      {
        label: "月份",
        prop: "month"
      },
      {
        label: "燃料名称",
        prop: "fuelName"
      },
      {
        label: "月消耗量",
        prop: "consumption"
      },
      {
        label: "碳排放量(kgCo2)",
        prop: "carbonEmission"
      }
    ]
  };
};

export default tableOption;
